import { render, staticRenderFns } from "./ExchangePast.vue?vue&type=template&id=18d909d5&scoped=true&"
import script from "./ExchangePast.vue?vue&type=script&lang=js&"
export * from "./ExchangePast.vue?vue&type=script&lang=js&"
import style0 from "./ExchangePast.vue?vue&type=style&index=0&id=18d909d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d909d5",
  null
  
)

export default component.exports